<template>
    <div>
        <!--<registration-bonus-banner v-if="registrationBanner"
        :currency="currency" />-->

        <form @submit.prevent="submit()" :class="{ 'is-loading' : loading }" role="form">
            <!-- Login input-->
            <div class="field">
                <div class="control has-icons-left is-expanded">
                    <input v-model.trim="login"
                           v-validate="'required|min:3|max:50|unique-login'"
                           data-vv-name="login"
                           data-vv-validate-on="input"
                           data-vv-delay="300"
                           :placeholder="'components.pages.registration.login' | translate"
                           class="input is-large"
                           maxlength="50"
                           autofocus
                           autocomplete="login"
                           type="text" />
                    <span class="icon is-small is-left"><i class="fas fa-user"></i></span>
                </div>
                <p class="help is-danger" v-if="errors.has('login:required')">{{"components.pages.registration.validation.login required" | translate}}</p>
                <p class="help is-danger" v-if="errors.has('login:min')">{{"components.pages.registration.validation.login min length" | translate}}</p>
                <p class="help is-danger" v-if="errors.has('login:max')">{{"components.pages.registration.validation.login max length" | translate}}</p>
                <p class="help is-danger" v-if="errors.has('login:unique-login')">{{"components.pages.registration.validation.login in use" | translate}}</p>
            </div>
            <!-- Password input-->
            <div class="field">
                <div class="control has-icons-left has-icons-right">
                    <input v-model.trim="password"
                           v-validate="{required:true, min:4, max:20, regex:/^[^\s]+$/}"
                           data-vv-name="password"
                           data-vv-validate-on="input"
                           :placeholder="'components.pages.registration.password' | translate"
                           class="input is-large"
                           :type="showPassword ? 'text' : 'password'"
                           maxlength="20"
                           ref="password" />
                    <span class="icon is-small is-left"><i class="fas fa-lock"></i></span>
                    <a class="icon is-small is-right bng-clickable" @click="toggleShowPassword('password')">
                        <span v-show="!showPassword"><i class="far fa-eye-slash"></i></span>
                        <span v-show="showPassword"><i class="far fa-eye"></i></span>
                    </a>
                </div>
                <p class="help is-danger" v-if="errors.has('password:required')">{{"components.pages.registration.validation.password required" | translate}}</p>
                <p class="help is-danger" v-if="errors.has('password:min')">{{"components.pages.registration.validation.password min length" | translate}}</p>
                <p class="help is-danger" v-if="errors.has('password:max')">{{"components.pages.registration.validation.password max length" | translate}}</p>
            </div>
            <div class="field">
                <div class="control has-icons-left has-icons-right">
                    <input v-model.trim="confirmedPassword"
                           v-validate="{ required: true, is: password }"
                           data-vv-name="confirmedPassword"
                           data-vv-validate-on="input"
                           :placeholder="'components.pages.registration.repeat password' | translate"
                           class="input is-large"
                           :type="showPassword ? 'text' : 'password'"
                           maxlength="20"
                           ref="confirmedPassword" />
                    <span class="icon is-small is-left"><i class="fas fa-lock"></i></span>
                    <a class="icon is-small is-right bng-clickable" @click="toggleShowPassword('password')">
                        <span v-show="!showPassword"><i class="far fa-eye-slash"></i></span>
                        <span v-show="showPassword"><i class="far fa-eye"></i></span>
                    </a>
                </div>
                <p class="help is-danger" v-if="errors.has('confirmedPassword:required')">{{"components.pages.registration.validation.password required" | translate}}</p>
                <p class="help is-danger" v-if="errors.has('confirmedPassword:is')">{{"components.pages.login.validation.confirmed" | translate}}</p>
            </div>
            <!-- Alias input-->
            <div v-if="askAliasDuringRegistration" class="field">
                <div class="control has-icons-left">
                    <input v-model.trim="alias"
                           v-validate="'min:3|max:50'"
                           data-vv-name="alias"
                           data-vv-validate-on="input"
                           :placeholder="'components.pages.registration.alias' | translate"
                           class="input is-large"
                           type="text"
                           maxlength="30" />
                    <span class="icon is-small is-left">
                        <i class="fas fa-user"></i>
                    </span>
                </div>
                <p class="help is-danger" v-if="errors.has('alias:min')">{{"components.pages.registration.validation.alias min length" | translate}}</p>
                <p class="help is-danger" v-if="errors.has('alias:max')">{{"components.pages.registration.validation.alias max length" | translate}}</p>
            </div>
            <!-- Recaptcha-->
            <div v-if="false" class="has-text-centered">
                <recaptcha ref="recaptcha" :on-response="response => { recaptchaResponse = response; }" />
            </div>
            <!-- Currency input-->
            <div v-if="visibleCurrencies && visibleCurrencies.length > 1"
                 class="field bng-center-field">
                <div class="control has-icons-left">
                    <div class="select is-large">
                        <select v-model="currency"
                                v-validate="'required'"
                                data-vv-name="currency"
                                data-vv-validate-on="change">
                            <option :value="null">
                                {{ 'components.pages.registration.choose currency' | translate }}
                            </option>
                            <option v-for="(c, index) of visibleCurrencies" :key="index" :value="c.id">
                                {{ c.description }} ({{ c.id }})
                            </option>
                        </select>
                    </div>
                    <span class="icon is-left"><i class="fas fa-money-bill-alt"></i></span>
                    <p class="help is-danger" v-if="errors.has('currency:required')">{{"components.pages.registration.validation.currency required" | translate}}</p>
                </div>
            </div>
            <!-- Agreement input-->
            <div class="field bng-center-field">
                <div class="control">
                    <label class="checkbox">
                        <input v-model="agreement"
                               v-validate="'required'"
                               data-vv-name="agreement"
                               data-vv-validate-on="change"
                               type="checkbox" />
                        <span>{{'components.pages.registration.agreement' | translate}}</span>
                        <router-link target="_blank" :to="{ name: 'rules-inner', params: { rule: mainRulesRef && mainRulesRef.name } }">{{'components.pages.registration.agreement rules' | translate}}</router-link>
                    </label>
                    <p class="help is-danger" v-if="errors.has('agreement:required')">{{"components.pages.registration.validation.agreement required" | translate}}</p>
                </div>
            </div>
            <!-- Submit-->
            <button class="card-footer-item button is-large is-link button-register" :class="{ 'is-loading': loading }" type="submit">
                <span v-if="!loading">{{"components.pages.registration.register" | translate}}</span>
                <span class="icon" v-if="loading"><i class="fas fa-circle-notch fa-pulse"></i></span>
            </button>
        </form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters } from 'vuex';

    import registrationService from '../../../../../../_common/services/registration.service';
    import rulesHelper from '../../../../../../_common/helpers/rules.helper';
    import currencyHelper from '../../../../../../_common/helpers/currency.helper';

    import UniqueLoginValidationRule from '../../../../../../_common/mixins/unique-login.validation-rule.mixin';

    import Recaptcha from '../../../common/recaptcha/recaptcha.vue';
    //import RegistrationBonusBanner from "../banners/registration-bonus";

    export default {
        name: 'registration-by-login',
        $_veeValidate: { validator: 'new' },
        props: {
            branchCode: {
                type: String
            }
        },
        components: { Recaptcha }, //, RegistrationBonusBanner
        mixins: [UniqueLoginValidationRule],
        $_veeValidate: { validator: 'new' },
        data() {
            return {
                showPassword: false,
                login: '',
                password: '',
                confirmedPassword: '',
                alias: null,
                currency: null,
                recaptchaResponse: null,
                agreement: false,
                loading: false,
                mainRulesRef: null,
                visibleCurrencies: null
            };
        },
        computed: {
            ...mapGetters(['client']),
            askAliasDuringRegistration() {
                return this.client && this.client.view.auth.askAliasDuringRegistration;
            },
            registrationBonus() {
                let client = Vue.state.client.get();
                return client && client.bonus && client.bonus.registration;
            },
            registrationBanner() {
                return (
                    this.client &&
                    this.client.view.banners.registrationBanner &&
                    this.registrationBonus &&
                    this.registrationBonus.registrationTypes.indexOf('login') >= 0
                );
            },
            lang() {
                return Vue.state.lang.currentLang;
            }
        },
        async created() {
            this.visibleCurrencies = await currencyHelper.getVisibleCurrencies();
            if (this.visibleCurrencies && this.visibleCurrencies.length) {
                this.currency = this.visibleCurrencies[0].id;
            }

            this.mainRulesRef = await rulesHelper.getMainRulesRef(this.lang);
        },
        methods: {
            toggleShowPassword(ref) {
                this.showPassword = !this.showPassword;
                setTimeout(() => this.$refs[ref].focus());
            },
            async submit() {
                await this.$validator.validateAll();
                if (this.errors.any() || this.loading) return;

                this.errors.clear();
                this.loading = true;
                let registrationRequest = {
                    username: this.login,
                    password: this.password,
                    language: Vue.state.lang.currentLang,
                    currency: this.currency,
                    alias: this.alias,
                    recaptchaResponse: this.recaptchaResponse,
                    branchCode: this.branchCode
                };
                let result = await registrationService.register(registrationRequest);
                await Vue.state.player.reload();

                this.loading = false;

                Vue.state.lang.ensureLocalLangOrPlayer(Vue.state.player.get().lang || 'en');

                await Vue.router.teleport.afterRegistration();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/registration/by-login.vue